import { render, staticRenderFns } from "./salePig.vue?vue&type=template&id=c846fcd0&scoped=true"
import script from "./salePig.vue?vue&type=script&lang=js"
export * from "./salePig.vue?vue&type=script&lang=js"
import style0 from "./salePig.vue?vue&type=style&index=0&id=c846fcd0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c846fcd0",
  null
  
)

export default component.exports